import {Module} from 'vuex'
import {state} from './state'
import {ICompaniesStateModel, IRootStateModel} from './../../interfaces'
import { mutations } from './mutations'
import { getters } from './getters'
import { actions } from './actions'

const comments: Module<ICompaniesStateModel, IRootStateModel> = {
    state,
    mutations,
    getters,
    actions
}

export default comments;